export enum PageTitle {
	MY_TICKETS = 'My Tickets',
	OPEN_TICKETS = 'Open Tickets',
	ALL_TICKETS = 'All Tickets',
	MANAGE_INSTALLERS = 'Manage Installers',
	OVERDUE_TICKETS = 'Overdue Tickets'
}
